module.exports = __webpack_public_path__ + "img/cgjz-4.fa18a180.jpg";